<template>
  <div>
    <vxe-grid
      ref="table"
      border
      resizable
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      row-id="waybillCode"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <b-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              content="称重登记"
              placement="top"
            >
              <i
                class="el-icon-collection tool-btn"
                @click="weigh(row.waybillCode)"
              >
              </i>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              content="填报车辆信息"
              placement="top"
              v-if="row.wayBillStatus === '0' || row.wayBillStatus === '2'"
            >
              <i
                class="el-icon-user tool-btn"
                @click="$emit('isVehicle', [row.waybillCode])"
              >
              </i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="提货确认"
              placement="top"
              v-if="row.wayBillStatus === '0' || row.wayBillStatus === '2'"
            >
              <i class="el-icon-truck tool-btn" @click="$emit('isPickup', row)">
              </i>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              content="称重记录打印"
              placement="top"
            >
              <i class="el-icon-printer tool-btn" @click="print(row)"></i>
            </el-tooltip>
          </b-button-group>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 204
    },
    weigh(code) {
      this.$router.push({
        name: 'carrier-weight-weightRecord-detail-page',
        params: { code },
      })
    },
    getCheckboxRecords() {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
      if (!data || !data.length) return false
      return data
    },
    print({ waybillCode }) {
      this.$api.bizWaybillWeightPrintJudgeApi({ waybillCode }).then(() => {
        this.$api.printPDF('/order/waybill/weight/print', { waybillCode })
      })
    },
  },
}
</script>
